import React, { useMemo, useState } from "react";

import { useGetSectorsQuery } from "@/src-refactor/modules/store/qrtk/services/geoLocation/geoLocation.qrtk";
import HCheckArray from "@rf-helper/check-have-value";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import {
  sectorAutoCompleteItem,
  sectorAutoCompleteItemAdapter
} from "@rf/adapters/autocomplete-items/sectorItemAdapters";

type omit = "items";
export interface MxSelectSectorsFieldProp
  extends Omit<MxAutoCompleteFieldProps, omit> {
  cityId?: number | undefined;
}
const MxSelectSectorsField = (props: MxSelectSectorsFieldProp) => {
  const [search, onSearch] = useState("");
  const GET_SECTORS = useGetSectorsQuery(
    {
      query: {
        q: search ?? "",
        cityId: props?.cityId,
        withCities: true
      }
    },
    {
      skip: !props?.cityId
    }
  );

  const Items: sectorAutoCompleteItem[] | [] = useMemo(() => {
    if (GET_SECTORS?.data?.data == undefined) return [];
    if (HCheckArray(GET_SECTORS?.data?.data)) {
      return GET_SECTORS?.data?.data.map(item =>
        sectorAutoCompleteItemAdapter(item)
      );
    }
    return [];
  }, [GET_SECTORS.data]);

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={v => onSearch(v)}
      items={Items}
      loading={GET_SECTORS.isLoading}
    />
  );
};

export default MxSelectSectorsField;
